export const FREQUENCIES = [
  {
    text: 'Mensal',
    value: 'M',
  },
  {
    text: 'Trimestral',
    value: 'Q',
  },
  {
    text: 'Anual',
    value: 'Y',
  },
]

// ano da fundação AAWZ usado para intervalo de tempos na plataforma
// ex: mostrar um range de anos para selecionar em um filtro
export const REFERENCE_YEAR = '2018'

export const EVENT_TYPES = {
  RF: ['Cupom', 'Amortização', 'Vencimento', 'Resgate Parcial Antecipado'],
  RV: [
    'Dividendos',
    'Proventos',
    'Bonificação',
    'Desdobramento',
    'Agrupamento',
    'Subscrição',
    'Direito de Subscrição',
    'Juros Sobre Capital Próprio',
  ],
  Fundo: ['Come-Cotas'],
}

export const SPLIT_EVENT_TYPES = ['Desdobramento', 'Agrupamento']

export const MAP_MODULE_BACKGROUND_IMAGE = {
  'Financial Planning': {
    src: 'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/assets/images/pgbl/pgbl+5.png',
    offsetY: '-22px',
  },
  CRM: {
    src: 'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/assets/images/crm/crm-5.webp',
  },
  Compliance: {
    src: 'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/assets/images/compliance/compliance-1.webp',
    offsetY: '-22px',
  },
  'AAWZ Drive': {
    src: 'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/assets/images/aawz-drive/aawz-drive-6.png',
  },
}

export const DEFAULT_IMAGE_SRC =
  'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/assets/images/pgbl/pgblbanner1.png'
